
import { Control } from "ol/control.js";
import Geolocation from "ol/Geolocation.js";
import Feature from "ol/Feature.js";
import Point from "ol/geom/Point.js";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style.js";
import { Vector as VectorSource } from "ol/source.js";
import { Vector as VectorLayer } from "ol/layer.js";

export class CurrentLocationControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement("button");
    const tip = options.tipLabel || "Your Location";
    button.title = tip;
    button.setAttribute('aria-label', tip);
    const img = document.createElement("img");
    img.setAttribute("src", "my-location.png");
    img.className = "current-location-icon";
    button.appendChild(img);

    const element = document.createElement("div");
    element.className = "current-location ol-unselectable ol-control";
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener(
      "click",
      this.handleCurrentLocation.bind(this),
      false
    );
  }

  handleCurrentLocation() {
    const map = this.getMap();
    const view = map.getView();

    const geolocation = new Geolocation({
      tracking: true,
      trackingOptions: {
        enableHighAccuracy: true,
      },
      projection: view.getProjection(),
    });

    const accuracyFeature = new Feature();

    geolocation.on("change:accuracyGeometry", function () {
      accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
    });

    const positionFeature = new Feature();
    positionFeature.setStyle(
      new Style({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({
            color: "#3399CC",
          }),
          stroke: new Stroke({
            color: "#fff",
            width: 2,
          }),
        }),
      })
    );

    geolocation.on("change:position", function () {
      const coordinates = geolocation.getPosition();
      positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
    });

    new VectorLayer({
      map: map,
      source: new VectorSource({
        features: [accuracyFeature, positionFeature],
      }),
    });

    geolocation.on("change:position", function () {
      const coordinates = geolocation.getPosition();
      view.animate({
        center: coordinates,
        duration: 750,
      });
      geolocation.setTracking(false);
    });
  }
}